import { FileSpreadsheet, Upload } from 'lucide-react';
import * as React from 'react';
import { cn } from '@payment-plan/ui';

interface UploadDropzoneProps {
  onFile: (file: File) => void;
  disabled?: boolean;
  fileName?: string;
}

export function UploadDropzone({ onFile, disabled, fileName }: UploadDropzoneProps): React.JSX.Element {
  const inputId = 'catalog-file';
  return (
    <label
      htmlFor={inputId}
      className={cn(
        'group flex cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-border bg-surface-fade px-6 py-10 text-center transition-all duration-300 hover:border-brand-gold hover:shadow-elegant',
        disabled && 'pointer-events-none opacity-60',
      )}
    >
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gold-sheen">
        {fileName ? (
          <FileSpreadsheet className="h-6 w-6 text-brand-gold-dark" />
        ) : (
          <Upload className="h-6 w-6 text-brand-gold-dark" />
        )}
      </span>
      <span className="text-sm font-medium text-foreground">
        {fileName ?? 'Arrastra el archivo .xlsx o haz clic para seleccionarlo'}
      </span>
      <span className="text-xs text-muted-foreground">Solo formato Excel (.xlsx)</span>
      <input
        id={inputId}
        aria-label="Archivo Excel"
        type="file"
        accept=".xlsx"
        className="sr-only"
        disabled={disabled}
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) {
            onFile(file);
          }
        }}
      />
    </label>
  );
}
